/* SeeMy — formulaires Klaviyo (newsletter pied de page, panier, fiche formation).
   API client Klaviyo (clé publique du compte), aucune clé privée côté navigateur. */
(function () {
  var COMPANY = 'S9xiFB';
  var LIST_EMAIL = 'SvQ6cf'; // Liste d'adresses e-mail (double opt-in)
  var LIST_SMS = 'WkBdvD';   // Liste pour la messagerie texte
  var REVISION = '2025-07-15';
  var BASE = 'https://a.klaviyo.com/client/';
  var SOURCES = { footer: 'Site — pied de page', cart: 'Site — panier', fiche: 'Site — fiche formation' };

  function post(path, body) {
    return fetch(BASE + path + '/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
    });
  }

  function subscribe(listId, attrs, channels, source) {
    var subs = {};
    if (channels.email) subs.email = { marketing: { consent: 'SUBSCRIBED' } };
    if (channels.sms) subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var p = { email: attrs.email, subscriptions: subs };
    if (attrs.first_name) p.first_name = attrs.first_name;
    if (attrs.last_name) p.last_name = attrs.last_name;
    if (channels.sms) p.phone_number = attrs.phone;
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: p } } },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }

  function trackFiche(attrs, props) {
    var p = { email: attrs.email };
    if (attrs.first_name) p.first_name = attrs.first_name;
    if (attrs.last_name) p.last_name = attrs.last_name;
    return post('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Fiche formation demandée' } } },
          profile: { data: { type: 'profile', attributes: p } }
        }
      }
    });
  }

  // Numéro français ou international -> format E.164 (+33612345678)
  function toE164(raw) {
    var s = (raw || '').replace(/[\s.\-()]/g, '');
    if (s.indexOf('00') === 0) s = '+' + s.slice(2);
    if (/^0[1-9]\d{8}$/.test(s)) s = '+33' + s.slice(1);
    return /^\+[1-9]\d{7,14}$/.test(s) ? s : '';
  }

  function setStatus(form, msg, isError) {
    var st = form.querySelector('.sm-optin__status');
    st.textContent = msg;
    st.classList.toggle('is-error', !!isError);
  }

  function markInvalid(input, bad) {
    if (!input) return;
    if (bad) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  }

  function init(form) {
    var v = form.getAttribute('data-sm-optin');
    var smsBox = form.querySelector('[data-sm-sms-toggle]');
    var telWrap = form.querySelector('.sm-optin__field--tel');
    var tel = form.querySelector('input[name="phone"]');

    smsBox.addEventListener('change', function () {
      telWrap.hidden = !smsBox.checked;
      smsBox.setAttribute('aria-expanded', smsBox.checked ? 'true' : 'false');
      if (smsBox.checked) tel.focus();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.classList.contains('is-busy')) return;
      var val = function (n) { var el = form.elements[n]; return el ? el.value.trim() : ''; };
      var emailIn = form.elements.email;
      var email = val('email');
      var wantsEmail = v === 'footer' || (form.elements.consent_email && form.elements.consent_email.checked);
      var wantsSms = smsBox.checked;
      var phone = wantsSms ? toE164(val('phone')) : '';
      var attrs = { email: email, first_name: val('first_name'), last_name: val('last_name'), phone: phone };

      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
      markInvalid(emailIn, !okEmail);
      if (!okEmail) { setStatus(form, 'Merci d’indiquer une adresse e-mail valide.', true); emailIn.focus(); return; }
      if (wantsSms && !phone) { markInvalid(tel, true); setStatus(form, 'Merci d’indiquer un numéro de mobile valide (ex. 06 12 34 56 78).', true); tel.focus(); return; }
      markInvalid(tel, false);

      var props = null;
      if (v === 'fiche') {
        var missing = ['first_name', 'last_name', 'formation'].filter(function (n) { return form.elements[n] && !val(n); });
        missing.forEach(function (n) { markInvalid(form.elements[n], true); });
        ['first_name', 'last_name', 'formation'].forEach(function (n) { if (missing.indexOf(n) < 0) markInvalid(form.elements[n], false); });
        if (missing.length) { setStatus(form, 'Merci de compléter les champs obligatoires.', true); form.elements[missing[0]].focus(); return; }
        var sel = form.elements.formation;
        var formation = form.getAttribute('data-formation') || val('formation');
        var url = form.getAttribute('data-formation-url') || (sel && sel.selectedOptions[0] ? sel.selectedOptions[0].getAttribute('data-url') : '') || location.href;
        props = { formation: formation, formation_url: url, statut: val('statut'), page: location.href, optin_email: !!wantsEmail, optin_sms: !!wantsSms };
      } else if (!wantsEmail && !wantsSms) {
        setStatus(form, 'Cochez au moins une case pour valider vos préférences.', true);
        return;
      }

      var jobs = [];
      var source = SOURCES[v] || 'Site';
      if (props) jobs.push(trackFiche(attrs, props));
      if (wantsEmail) jobs.push(subscribe(LIST_EMAIL, attrs, { email: true }, source));
      if (wantsSms) jobs.push(subscribe(LIST_SMS, attrs, { sms: true }, source));

      form.classList.add('is-busy');
      setStatus(form, 'Envoi en cours…');
      Promise.all(jobs).then(function () {
        var msg;
        if (v === 'fiche' && form.hasAttribute('data-sm-offre')) msg = 'Merci ! Notre catalogue de formation vous sera envoyé par e-mail dans quelques minutes.';
        else if (v === 'fiche') msg = 'Merci ! La fiche détaillée vous sera envoyée par e-mail dans quelques minutes.';
        else msg = 'Merci ! ';
        if (wantsEmail) msg += (v === 'fiche' ? ' ' : '') + 'Confirmez votre inscription grâce à l’e-mail que nous venons de vous envoyer.';
        else if (wantsSms && v !== 'fiche') msg += 'Votre inscription aux SMS est enregistrée.';
        form.classList.add('is-done');
        setStatus(form, msg.trim());
        form.reset();
        telWrap.hidden = true;
        smsBox.setAttribute('aria-expanded', 'false');
      }).catch(function () {
        setStatus(form, 'Une erreur est survenue. Réessayez ou écrivez-nous à contact@seemycosmetics.com.', true);
      }).then(function () { form.classList.remove('is-busy'); });
    });
  }

  function boot() { document.querySelectorAll('form[data-sm-optin]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
